<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn icon>
        <v-icon v-on="on">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in menuItems"
        :key="index"
        @click="clickAction(item.action)">
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data () {
    return {
      menuItems: [
        { title: 'Logout', action: 'signOut' }
      ]
    }
  },
  methods: {
    clickAction(e) {
      this.$emit(e)
    }
  }
}
</script>